import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import "./hero-carousel.m.css";

const HeroCarousel = (props) => {
  const collection = props.collection;
  const cdnHost = useSelector((state) => get(state, ["qt", "config", "cdn-image"]));
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalSlides = 3;
  const eventStory = collection?.items?.find(item => item.type === "story" && ['conference', 'workshop', 'session'].includes(item.story?.['story-template']));
  const researchStory = collection?.items?.find(item => item.type === "story" && item.story?.['story-template'] === "text");

  const carouselData = [
    {
      title: "India’s leadership intelligence network. See further, look beyond",
      subtitle: "Independent insights, CXO Forums, curated workshops and 30+ years of trusted peer exchange — built for leaders shaping business in India.",
      buttonText: "Explore peer groups",
      buttonLink: "/peer-group-forums",
      backgroundImage: collection?.metadata?.['cover-image']?.url,
      slideHeight: '560px',
    },
    {
      header: 'Latest event',
      title: eventStory?.story?.headline,
      buttonText: "Explore event",
      buttonLink: eventStory?.story?.url,
      backgroundImage: `https://${cdnHost}/${eventStory?.story?.['hero-image-s3-key']}`,
    },
    {
      header: "Latest research",
      title: researchStory?.story?.headline,
      buttonText: "Explore research",
      buttonLink: "/collection/research-hub",
      backgroundImage: `https://${cdnHost}/${researchStory?.story?.['hero-image-s3-key']}`,
    }
  ];

  const activeSlide = carouselData?.[currentSlide];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(timer);
  }, [totalSlides]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div styleName="hero-carousel">
      <div styleName="carousel-content">
        <div
          styleName="background-image"
          style={{ backgroundImage: `url(${activeSlide?.backgroundImage})` }}
        />
        <div styleName="hero-container">
          <div styleName="content-wrapper">
            <div styleName="text-content">
              {activeSlide.header && (
                <span styleName="title header">{activeSlide.header}</span>
              )}
              <h1 styleName="title">
                {activeSlide.title}
              </h1>
              {activeSlide.subtitle && <p styleName="subtitle">
                {activeSlide.subtitle}
              </p>}
              <div styleName="button-container">
                <a
                  href={activeSlide.buttonLink}
                  styleName="cta-button"
                >
                  {activeSlide.buttonText}
                </a>
              </div>
            </div>
            <div styleName="slider-dots">
              {Array.from({ length: totalSlides }).map((_, index) => (
                <button
                  key={index}
                  styleName={`dot ${currentSlide === index ? 'active-dot' : ''}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default HeroCarousel;